import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';

const modalWrapperSx = (theme) => ({
  padding: '20px',
  '& h2': {
    ...theme.mixins.marketplaceModalTitleStyles,
  },
});

const modalTextWrapperSx = {
  marginTop: '20px',
  marginBottom: '40px',
  whiteSpace: 'pre-line',
};

const modalButtonWrapperSx = {
  marginTop: '24px',
};

const BookmarkLoginModal = ({
  bookmarkLoginRequiredModalOpen,
  onCloseBookmarkLoginRequiredModal,
  handleLoginFromBookmarkRequiredModal,
  onManageDisableScrolling,
}) => {
  return (
    <Modal
      id="BookmarkLoginRequiredModal"
      isOpen={bookmarkLoginRequiredModalOpen}
      onClose={onCloseBookmarkLoginRequiredModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Box sx={modalWrapperSx}>
        <FormattedMessage id="Page.bookmarkLoginRequiredModal.title" tagName="p" />
        <Box sx={modalTextWrapperSx}>
          <FormattedMessage id="Page.bookmarkLoginRequiredModal.text" />
        </Box>
        <Box sx={modalButtonWrapperSx}>
          <Button
            color="success"
            onClick={handleLoginFromBookmarkRequiredModal}
            size="large"
            variant="contained"
          >
            <FormattedMessage id="Page.bookmarkLoginRequiredModal.login" />
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default BookmarkLoginModal;
